/**
 * @ignore
 * User: daletan
 * Date: 1/13/16
 * Time: 11:24 AM
 * Copyright 1stdibs.com, Inc. 2016. All Rights Reserved.
 */

'use strict';

require('./src/jquery.operator');
require('./src/jquery.operator-shim');



//////////////////
// WEBPACK FOOTER
// ./~/jquery-operator/index.js
// module id = 722
// module chunks = 62